import "./index.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import AppShell from "../../components/appShell";
import LastSoldPlayer from "../../components/lastSoldPlayer";
import MostExpPlayer from "../../components/mostExpPlayer";
import PlayerDetails from "../../components/playerDetails";
import RtmPanel from "../../components/rtmPanel";
import PlayerBid from "../../components/playerBid";
import TeamBidding from "../../components/teamBidding";
import Modal from "../../components/modal";
import SelectLabels from "../../components/dropdowns/1/dropdown1";
import { Pill, money } from "../../components/atoms";
import {
  activeBidding,
  activeBlock as activeBlockk,
  bidStatus,
  createBid,
  finishBlock,
  franchises,
  getActiveSession,
  lastSoldPlayer,
  mostExpPlayer,
  resetBid,
  selectactiveBidding,
  selectactiveBlock,
  selectActiveSession,
  selectFranchisesData,
  selectinfo,
  selectisLoggedIn,
  selectLastSoldPlayer,
  selectmostExpPlayer,
  setPlayerSold,
  setPlayerSoldCustom,
  setPlayerUnsold,
  startBidding,
  stopBidding,
  stopBlock,
} from "../../store/features/curatorSlice";
import { useSocketRoom } from "../../hooks/useSocketRoom";

const CuratorPage = ({ socket }) => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let location = useLocation();
  let [TeamOptions, setTeamOptions] = useState([]);
  let [currentBid, setCurrentBid] = useState("");
  let [teamSelection, setTeamSelection] = useState({ option: "", value: "" });
  let [showLoading, setShowLoading] = useState(false);
  let [showEditBid, setShowEditBid] = useState(false);
  let [bidStopped, setBidStopped] = useState(false);
  let [counter, setCounter] = useState(1);
  let [content, setContent] = useState(
    "PLEASE WAIT... WHILE PLAYER IS BEING SELECTED"
  );
  let isLoggedIn = useSelector(selectisLoggedIn);
  let session = useSelector(selectActiveSession);
  let info = useSelector(selectinfo);

  // Rejoins on every reconnect, so a dropped socket recovers on its own. Placed
  // below the selectors it reads: `info` and `session` are consts declared
  // above, and calling this before them is a temporal dead zone error.
  useSocketRoom(socket, {
    role: "curator",
    id: info?._id,
    sessionId: session?.sessionId,
  });
  let activeBlock = useSelector(selectactiveBlock);
  let activePlayer = useSelector(selectactiveBidding);
  let TeamsData = useSelector(selectFranchisesData);
  let lsPlayer = useSelector(selectLastSoldPlayer);
  let msPlayer = useSelector(selectmostExpPlayer);

  useEffect(() => {
    dispatch(activeBlockk());
    dispatch(franchises());
    dispatch(lastSoldPlayer());
    dispatch(mostExpPlayer());
    dispatch(activeBidding());
    dispatch(getActiveSession());
  }, [counter]);

  useEffect(() => {
    setTeamOptions(
      TeamsData?.map((data) => ({
        option: data?.name,
        value: data?._id,
        data: data,
      }))
    );
  }, [TeamsData]);

  useEffect(() => {
    if (session?.sessionId) {
      socket.on("bid-updated", () => {
        setCounter((a) => a + 1);
        // setShowLoading(true);
        // // console.log(playerType);
        // setContent(playerType?.toUpperCase() + " BLOCK STARTED!");
        // setTimeout(() => {
        //   setShowLoading(false);
        //   setContent("PLEASE WAIT... WHILE PLAYER IS BEING SELECTED");
        // }, 3000);
      });
      // Each step of the Right To Match round refetches quietly: the curator is
      // watching, not acting, so a full-screen notice on every stage would be
      // four interruptions per player.
      socket.on("rtm-stage-changed", () => {
        setCounter((a) => a + 1);
      });
      socket.on("rtm-updated", () => {
        setContent(<>RTM Applied</>);
        setShowLoading(true);
        // console.log(playerType);
        setCounter((a) => a + 1);
        setTimeout(() => {
          setShowLoading(false);
          setContent("PLEASE WAIT... WHILE PLAYER IS BEING SELECTED");
        }, 1000);
      });
      socket.on("block-bidding", () => {
        // console.log(bidStopped);
        if (bidStopped)
          socket.emit("block-bidding-curator", {
            status: bidStopped,
            sessionId: session?.sessionId,
          });
      });
    }
  }, [bidStopped, session?.sessionId]);

  // The server sends these to every device signed in as this curator, not just
  // the one that pressed the button, so a room run from a laptop and a phone
  // stays in step. They are registered once here rather than inside each click
  // handler: a handler only ever registered on the acting device, and stacked
  // another copy of itself on every click.
  useEffect(() => {
    const reload = () => window.location.reload();
    const toPlayerList = () => {
      window.location.href = "/curator/playerlist";
    };
    const stopped = () => setBidStopped(true);
    const resumed = () => setBidStopped(false);

    socket.on("player-sold-executed", reload);
    socket.on("block-finished-curator", reload);
    socket.on("block-pause-curator", toPlayerList);
    socket.on("stop-bidding-executed", stopped);
    socket.on("resume-bidding-executed", resumed);

    return () => {
      socket.off("player-sold-executed", reload);
      socket.off("block-finished-curator", reload);
      socket.off("block-pause-curator", toPlayerList);
      socket.off("stop-bidding-executed", stopped);
      socket.off("resume-bidding-executed", resumed);
    };
  }, [socket]);

  useEffect(() => {
    if (!bidStopped) {
      setCurrentBid(activePlayer?.currentBid);
      setTeamSelection({
        option: activePlayer?.lastBidBy?.team,
        value: activePlayer?.lastBidBy?.franchise,
      });
    }
  }, [activePlayer?.currentBid, activePlayer?.lastBidBy]);

  const onCreateBid = async () => {
    if (session?.sessionId) {
      let res = await dispatch(createBid());
      if (res?.payload?.statusCode === 200) {
        let res2 = await dispatch(activeBidding());
        if (res2?.payload?.statusCode === 200) {
          socket.emit("create-bid", {
            ...res2?.payload,
            sessionId: session?.sessionId,
          });
        }
      }
    }
  };

  const onSellPlayerBtn = async () => {
    if (window.confirm("are you sure?") && session?.sessionId) {
      let res = await dispatch(setPlayerSold());
      console.log(res);
      if (res?.payload?.statusCode === 200) {
        socket.emit("player-sold", {
          ...activePlayer,
          sessionId: session?.sessionId,
        });
      }
    }
  };

  const onUnSellBtn = async () => {
    let check = window.confirm("are you sure?");
    if (check && session?.sessionId) {
      let res = await dispatch(setPlayerUnsold());
      if (res?.payload?.statusCode === 200) {
        let res2 = await dispatch(activeBidding());
        if (res2?.payload?.statusCode === 200) {
          socket.emit("player-unsold", {
            ...activePlayer,
            sessionId: session?.sessionId,
          });
          window.location.reload();
        } else {
          window.location.reload();
        }
      }
    }
  };

  const onResetBtn = async () => {
    if (window.confirm("Are you sure? this will reset the current bidding")) {
      let res = await dispatch(resetBid());
      if (res?.payload?.statusCode === 200 && session?.sessionId) {
        socket.emit("reset-bid", session?.sessionId);
        window.location.reload();
      }
    }
  };

  const onEditBidBtn = async () => {
    setShowEditBid(true);
  };

  const onFinishedBtn = async () => {
    let res = await dispatch(finishBlock());
    if (res?.payload?.statusCode === 200 && session?.sessionId) {
      let res2 = await dispatch(activeBidding());
      if (res2?.payload?.statusCode === 200 && session?.sessionId) {
        socket.emit("finish-block", {
          ...activeBlock,
          sessionId: session?.sessionId,
        });
      }
    }
  };

  const pauseAuctionBtn = async () => {
    let check = window.confirm("are you sure?");
    if (check && session?.sessionId) {
      let res = await dispatch(stopBlock());

      if (res?.payload?.statusCode === 200) {
        let res2 = await dispatch(activeBidding());
        console.log(res2);

        if (res2?.payload?.statusCode === 200) {
          socket.emit("pause-block", {
            ...activeBlock,
            sessionId: session?.sessionId,
          });
        }
      }
    }
  };

  const onStoppedSelling = async () => {
    // The server call goes first. Stopping opens the Right To Match round and
    // resuming cancels it, so telling the room before that work is done sends
    // every bidder off to refetch a player that has not changed yet.
    if (bidStopped && session?.sessionId) {
      await dispatch(startBidding());
      await dispatch(bidStatus({ status: false }));
      socket.emit("resume-bidding", session?.sessionId);
      setCounter((a) => a + 1);
    } else if (session?.sessionId) {
      await dispatch(stopBidding());
      await dispatch(bidStatus({ status: true }));
      socket.emit("stop-bidding", session?.sessionId);
      setCounter((a) => a + 1);
    }
    setBidStopped(!bidStopped);
  };

  // useEffect(() => {
  //   socket.emit("publicEntry");
  //   socket.on("connected", () => {
  //     socket.emit("join room", 35);
  //   });
  //   socket.on("block-started", (playerType) => {
  //     setShowLoading(true);
  //      // console.log(playerType);
  //     setContent(playerType?.toUpperCase() + " BLOCK STARTED!");
  //     setTimeout(() => {
  //       setShowLoading(false);
  //       setContent("PLEASE WAIT... WHILE PLAYER IS BEING SELECTED");
  //     }, 3000);
  //   });
  // }, []);

  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location, isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/curator/login");
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return (
      <AppShell role="public">
        <h1 className="au-heading">Not signed in</h1>
        <p className="au-subheading">
          <Link to="/curator/login">Sign in as a curator</Link> to open the
          auction room.
        </p>
      </AppShell>
    );
  }

  if (!session?.sessionId) {
    return (
      <AppShell role="curator">
        <h1 className="au-heading">Auction Room</h1>
        <p className="au-subheading">
          No auction is running. <Link to="/curator/playerlist">Open the
          player list</Link> to start a category.
        </p>
      </AppShell>
    );
  }

  const hasPlayer = Boolean(activePlayer?._id);
  const playersLeft = activeBlock?.players?.length || 0;

  return (
    <AppShell role="curator">
      {(!activeBlock?._id || !session?.sessionId) && (
        <Navigate to="/curator/playerlist" replace />
      )}

      <Modal show={showLoading} content={content} />

      <Modal
        show={showEditBid}
        setShow={setShowEditBid}
        title="Edit the current bid"
      >
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (window.confirm("are you sure?") && session?.sessionId) {
              let res = await dispatch(
                setPlayerSoldCustom({
                  franchiseId: teamSelection?.value,
                  currentBid: currentBid,
                })
              );
              if (res?.payload?.statusCode === 200) {
                socket.emit("player-sold", {
                  ...activePlayer,
                  currentBid,
                  lastBidBy: {
                    team: teamSelection?.option,
                    Franchise: teamSelection?.value,
                  },
                  sessionId: session?.sessionId,
                });
              }
            }
          }}
        >
          <div className="au-card">
            <div className="edit-field">
              <label className="au-label" htmlFor="edit-bid">
                Current bid
              </label>
              <input
                id="edit-bid"
                className="auth-input"
                type="number"
                min={activePlayer?.basePrice}
                value={currentBid}
                onChange={(e) => setCurrentBid(e.target.value)}
              />
              <p className="au-hint">
                In lakhs. The base price is {money(activePlayer?.basePrice)}.
              </p>
            </div>

            <div className="edit-field">
              <label className="au-label">Sold to</label>
              <SelectLabels
                name="Franchise"
                slist={TeamOptions}
                active={teamSelection}
                setActive={(e) => {
                  let option = TeamOptions.find(
                    (t) => t?.value?.toString() === e.target.value?.toString()
                  );
                  setTeamSelection(option);
                }}
              />
            </div>
          </div>

          <div className="au-modal-actions">
            <button
              type="button"
              className="au-btn secondary"
              onClick={() => setShowEditBid(false)}
            >
              Discard
            </button>
            <button type="submit" className="au-btn primary">
              Save
            </button>
          </div>
        </form>
      </Modal>

      <header className="room-head">
        <div>
          <h1 className="au-heading">Auction Room</h1>
          <p className="au-subheading">
            {activeBlock?.playerType
              ? `${activeBlock.playerType.trim()} category`
              : "Live auction"}
            {playersLeft > 0 &&
              ` · ${playersLeft} ${playersLeft === 1 ? "player" : "players"} left`}
          </p>
        </div>

        <div className="room-head-actions">
          {bidStopped && <Pill tone="warn">Bidding paused</Pill>}
          <button
            type="button"
            className="au-btn ghost"
            onClick={() => navigate("/curator/auction/playerlist")}
          >
            Player list
          </button>
          <button
            type="button"
            className="au-btn ghost"
            onClick={() => navigate("/curator/teamlist")}
          >
            Teams
          </button>
        </div>
      </header>

      <div className="room">
        <div className="room-main">
          <div className="room-stage">
            <PlayerDetails player={activePlayer} isCurator={true} />
            <PlayerBid player={activePlayer} />
            <TeamBidding player={activePlayer} />
          </div>

          <div className="room-results">
            <LastSoldPlayer player={lsPlayer} />
            <MostExpPlayer player={msPlayer} />
          </div>
        </div>

        <aside className="room-controls">
          <div className="room-control-group">
            <span className="au-label">On the block</span>

            {hasPlayer ? (
              <button
                type="button"
                className="au-btn primary block"
                onClick={onStoppedSelling}
              >
                {bidStopped ? "Resume bidding" : "Stop bidding"}
              </button>
            ) : (
              <button
                type="button"
                className="au-btn primary block"
                disabled={!playersLeft}
                onClick={onCreateBid}
              >
                Call next player
              </button>
            )}
          </div>

          {/* Read-only for the curator: they hold no team, so the panel shows
              the stage and who it is waiting on rather than any buttons. It
              tells them when the round is done and the lot can be closed. */}
          {activePlayer?.rtm?.stage &&
            activePlayer.rtm.stage !== "none" && (
              <div className="room-control-group">
                <RtmPanel player={activePlayer} franchise={null} />
              </div>
            )}

          <div className="room-control-group">
            <span className="au-label">Close the lot</span>
            <button
              type="button"
              className="au-btn success block"
              disabled={!activePlayer.currentBid || !bidStopped}
              onClick={onSellPlayerBtn}
            >
              Sell
            </button>
            <button
              type="button"
              className="au-btn danger block"
              disabled={
                (activePlayer._id ? activePlayer.currentBid : true) || !bidStopped
              }
              onClick={onUnSellBtn}
            >
              Mark unsold
            </button>
          </div>

          <div className="room-control-group">
            <span className="au-label">Corrections</span>
            <button
              type="button"
              className="au-btn block"
              disabled={!bidStopped}
              onClick={onEditBidBtn}
            >
              Edit bid
            </button>
            {playersLeft > 0 && (
              <button
                type="button"
                className="au-btn block"
                disabled={!activePlayer?.active}
                onClick={onResetBtn}
              >
                Reset bid
              </button>
            )}
          </div>

          <div className="room-control-group">
            <span className="au-label">Category</span>
            <button
              type="button"
              className="au-btn secondary block"
              disabled={activePlayer._id || !playersLeft}
              onClick={pauseAuctionBtn}
            >
              Pause auction
            </button>
            {!playersLeft && (
              <button
                type="button"
                className="au-btn secondary block"
                disabled={playersLeft && !bidStopped}
                onClick={onFinishedBtn}
              >
                Finish category
              </button>
            )}
          </div>
        </aside>
      </div>
    </AppShell>
  );
};

export default CuratorPage;
